import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c(VCard,{attrs:{"outlined":""}},[_c(VCardTitle,[_vm._v("Add Members")]),_c(VCardText,[_c(VList,_vm._l((_vm.filteredMembers),function(member){return _c(VListItem,{key:member.id,on:{"click":function($event){return _vm.selectMember(member)}}},[_c(VListItemAvatar,[_c(VImg,{attrs:{"src":member.image || '/default-user.jpg'}})],1),_c(VListItemContent,[_c(VListItemTitle,[_vm._v(_vm._s(member.name))])],1),_c(VListItemAction,[(_vm.selectedMember === member)?_c(VIcon,[_vm._v("mdi-check")]):_vm._e()],1)],1)}),1)],1),_c(VCardActions,[_c(VBtn,{attrs:{"color":"primary"},on:{"click":_vm.confirmSelection}},[_vm._v("Done")]),_c(VBtn,{attrs:{"color":"secondary"},on:{"click":_vm.closeDialog}},[_vm._v("Cancel")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }